export const GOOGLE_BUSINESS_VERTICAL = 'Google Dynamic Product Feed 2509'

export enum PaymentMode {
  ONSITE = 'onsite',
  ONLINE = 'online',
}
